import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTextIndicator: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconTextIndicator"><Path fillRule="evenodd" clipRule="evenodd" d="M16 2H22V4H20V20H22V22H16V20H18V4H16V2ZM2 5H14V7H9V19H7V7H2V5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconTextIndicator;
